import { makeBreakpoint } from '@utils/css';

const transitionDurationMs = 200;
const mobileFiltersBreakpoint = makeBreakpoint(0, 1100);
const section = "_275sn6otue";
const transitionWrapper = "_275t6yzlri";
const header = "_275h1oy2556";
const mobileActions = "_275m1agbap6";
const chip = "_275c9zxsee";

export { chip, header, mobileActions, mobileFiltersBreakpoint, section, transitionDurationMs, transitionWrapper };
import "./root.style.linaria.module.css";
//# sourceMappingURL=root.style.js.map
